<!--
 * @Author: 曹捷
 * @Date: 2021-10-25 18:08:26
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-08 09:23:15
 * @Description: fileContent
-->
<template>
  <obitUniversalTable>
    <div class="myserver">
      <div class="container">
        <div v-for="item in appList" class="contentitem">
          <p>{{item.appName}}</p>
          <p>{{item.appDesc}}</p>
        </div>
      </div>
    </div>
  </obitUniversalTable>
</template>

<script>

import { inject, reactive, toRefs, onMounted } from 'vue'

export default {
  setup (props, context) {
    let http = inject('http')
    let _data = reactive({
      appList: [],
    })
    let _methods = {
      getAppInfo () {
        http.commonPost('system/app/myApp').then(res => {
          _data.appList = res
        })
      },
    }
    onMounted(() => {
      _methods.getAppInfo()
    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>

<style lang="less">
.myserver {
  width: 100%;
  margin: 0;
  padding: 28px;
  .container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .contentitem {
      height: 104px;
      width: 306.34px;
      margin: 0 28.55px 28.55px 0;
      padding: 16.18px 15.37px;
      border-image-source: linear-gradient(
        130.15deg,
        #f8ecff -9.45%,
        rgba(218, 157, 255, 0.554047) 46.9%,
        rgba(255, 255, 255, 0) 116.91%
      );
      background: url('../../../assets/images/myservice/appbg.png') no-repeat,
        linear-gradient(
          317.15deg,
          rgba(228, 185, 255, 0.3) 1.13%,
          rgba(255, 255, 255, 0) 46.2%
        );
      background-size: 100% 100%;
      backdrop-filter: blur(10px);
      :first-child {
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 1px;
        text-align: left;
      }
      :last-child {
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 1px;
        text-align: left;
      }
    }
  }
}
</style>